import React from 'react';
import './style.css';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        
    }
  }
  render(){
    return <div>
        <p>
         My Social Networks:
         <br/><br/>
         <a href="https://www.moddb.com/members/luizf34" target="_blank">
           Mod DB
         </a>
         <a href="https://steamcommunity.com/id/luizf34" target="_blank">
           Steam
         </a>
        </p>
    </div>
  };
}

export default Aba;